<template>
  <module-modal v-model:isOpen="show">
    <template v-slot:title>
      <base-headline class="headline" level="3">
        {{ headline }}
      </base-headline>
      <module-divider class="divider" />
    </template>
    <img v-lazy="config.baseUrl + '/storage/' + image" :alt="headline" class="image" />
    <div class="description mt-8" v-html="description" />
    <module-divider class="divider" />
    <div class="footer" v-html="footer" />
  </module-modal>
</template>

<script lang="ts">
import { defineComponent, inject, ref } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import BaseHeadline from '@/components/base/BaseHeadline.vue'
import BaseText from '@/components/base/BaseText.vue'
import ModuleDivider from '@/components/module/ModuleDivider.vue'
import ModuleModal from '@/components/module/ModuleModal.vue'

export default defineComponent({
  props: {
    description: {
      type: String,
      default: 'Description',
    },
    footer: {
      type: String,
      default: 'Footer',
    },
    headline: {
      type: String,
      default: 'Headline',
    },
    image: {
      type: String,
      default: '',
    },
  },
  components: {
    BaseButton,
    BaseHeadline,
    BaseText,
    ModuleDivider,
    ModuleModal,
  },
  setup(props) {
    const show = ref(false)

    // import config
    const config: any = inject('config')

    const showTimed = setTimeout(() => {
      show.value = true
    }, 10000)

    return { config, show, showTimed }
  },
})
</script>

<style scoped>
.divider {
  @apply py-2;
}

.footer {
  @apply font-bold mt-3;
}

.footer ::v-deep(p) {
  @apply mb-0;
}

.footer ::v-deep(a) {
  @apply underline;
}

.headline {
  @apply pr-8;
}

.image {
  @apply object-cover w-full h-full mt-3;
}
</style>
